import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { SectionCard, SectionHeader, SectionTitle, CloseButton, SectionText, StyledCollapse } from './styles';
import { PerformanceMetricsSectionProps } from './types';

const { Panel } = StyledCollapse;

const PerformanceMetricsSection: React.FC<PerformanceMetricsSectionProps> = ({
  performanceMetrics,
  isOpen,
  onClose,
}) => {
  return (
    <StyledCollapse activeKey={isOpen ? ['performanceMetrics'] : []} ghost expandIcon={() => null}>
      <Panel key="performanceMetrics" header={null}>
        <SectionCard>
          <SectionHeader>
            <SectionTitle level={4}>Performance Metrics</SectionTitle>
            <CloseButton
              type="text"
              icon={<CloseOutlined />}
              onClick={onClose}
              aria-label="Close"
            />
          </SectionHeader>
          <SectionText>Service Speed: {performanceMetrics.serviceSpeed}</SectionText>
          <SectionText>Customer Feedback: {performanceMetrics.customerFeedback}</SectionText>
          <SectionText>Sales Summary: ${performanceMetrics.salesSummary}</SectionText>
        </SectionCard>
      </Panel>
    </StyledCollapse>
  );
};

export default PerformanceMetricsSection;
